<template>
  <public-page>
    <div class="terms">
      <quick-links-card />
    </div>
  </public-page>
</template>

<script>
import PublicPage from './PublicPage'
import QuickLinksCard from '../cards/QuickLinksCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'quick-links',
  components: {
    PublicPage,
    QuickLinksCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/quick-links',
      ogTitle: 'Quick Links - Rewarding Dog Training',
      ogDescription: 'Rewarding Dog Training quick links!',
    })
  },
}
</script>

<style lang="scss">
.terms {
  margin-bottom: 6rem;
}
</style>
